export enum ProviderType {
  Agency = 1,
  Independent = 2,
  DOE = 3
}